// extracted by mini-css-extract-plugin
export default {"wrapper":"bossPage_wrapper__vFmnn","cardWrapper":"bossPage_cardWrapper__YYnna"};